import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import PCF1 from '../assets/PCF1.jpeg';
import PCF3 from '../assets/PCF3.jpeg';
import PCF5 from '../assets/PCF5.jpeg';
import PCF6 from '../assets/PCF6.jpeg';

const products = [
  {
    id: 'pcf3',
    title: '7 oz Printed Paper Blank',
    image: PCF3,
    description: 'Compact-size blanks ideal for tea and coffee with colorful, eye-catching prints.',
    details: [
      'GSM: 140 - 220',
      'Material: Paper',
      'Color: Multi-color',
      'Usage: Tea / Coffee Paper Cups'
    ],
    modalDescription: 'Compact and vibrant paper blanks, perfect for serving tea, coffee, or small beverages.'
  },
  {
    id: 'pcf1',
    title: '8 oz Printed Paper Blank',
    image: PCF1,
    description: 'Versatile mid-size blanks perfect for everyday use with excellent print quality.',
    details: [
      'GSM: 160 - 250',
      'Material: Paper',
      'Color: Multi-color',
      'Usage: Cold / Hot Drinks'
    ],
    modalDescription: 'Standard-sized blanks designed for hot or cold drinks, offering excellent print quality.'
  },
  {
    id: 'pcf5',
    title: '12 oz Printed Paper Blank',
    image: PCF5,
    description: 'Premium blanks designed for branding, suited for larger servings and cold drinks.',
    details: [
      'GSM: 250 - 300',
      'Material: Paper',
      'Color: Multi-color',
      'Usage: Coffee / Juice Cups'
    ],
    modalDescription: 'Medium-capacity blanks ideal for branding, with high GSM for durability and visual appeal.'
  },
  {
    id: 'pcf6',
    title: '16 oz Printed Paper Blank',
    image: PCF6,
    description: 'High-capacity blanks for smoothies and takeaway drinks, with bold print options.',
    details: [
      'GSM: 280 - 300',
      'Material: Paper',
      'Color: Multi-color',
      'Usage: Smoothies / Milkshakes'
    ],
    modalDescription: 'Large-size blanks crafted for cold beverages and takeaway use, with premium print finish.'
  }
];

const PaperCupFans = () => {
  const [openModal, setOpenModal] = useState(null);

  const closeModal = () => setOpenModal(null);

  return (
    <>
      <Navbar />
      <section id="products" className="py-20 bg-gray-100 min-h-screen">
        <div className="container mx-auto px-5">
          <h2 className="text-center text-4xl mb-16 text-[#2c5530] font-bold relative after:content-[''] after:absolute after:bottom-[-10px] after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-gradient-to-r after:from-[#ff6b6b] after:to-[#ffa500] after:rounded">
            Paper Cup Fans
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            {products.map(({ id, title, image, description }) => (
              <div
                key={id}
                className="product-card bg-white rounded-2xl overflow-hidden shadow-xl hover:-translate-y-2 hover:shadow-2xl transition-all cursor-pointer flex flex-col h-[360px]"
                onClick={() => setOpenModal(id)}
              >
                <div className="h-48 bg-white flex items-center justify-center">
                  <img src={image} alt={title} className="object-contain mt-4" style={{ width: '200px', height: '200px' }} />
                </div>
                <div className="p-6 flex flex-col flex-grow justify-between">
                  <div>
                    <h3 className="text-xl text-[#2c5530] mb-2 font-semibold text-center">{title}</h3>
                    <p className="text-sm text-gray-600 text-center">{description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {openModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white p-6 rounded-lg w-full max-w-md relative shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-gray-600 text-2xl font-bold"
              aria-label="Close modal"
            >
              &times;
            </button>
            {products.map(
              ({ id, title, image, modalDescription, details }) =>
                openModal === id && (
                  <div key={id}>
                    <h3 className="text-2xl text-[#2c5530] font-semibold mb-4">{title}</h3>
                    <img src={image} alt={title} className="w-full h-48 object-contain mb-4" />
                    <p className="mb-2">{modalDescription}</p>
                    <ul className="list-disc pl-5 text-sm">
                      {details.map((detail, idx) => (
                        <li key={idx}>{detail}</li>
                      ))}
                    </ul>
                  </div>
                )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PaperCupFans;